<template>
    <div class="popup_st03">
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'road'">
            <div class="title"><span class="t02">{{ rdName }}</span></div>
            <div class="text">
                <span class="pop_bt_state blue">구간</span>
                <span v-show="spName != '' && epName != ''">{{ spName }} ~ {{ epName }}(구간거리: {{ distance }}m)</span>
            </div>
            <div class="traffic_box">
                <p :class="[clazz]">
                    <span class="txt01">{{ state }}</span>
                    <span class="txt01">{{ speed }}</span><span class="txt02">km/h</span>
                </p>
            </div>
        </div>
        
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'subway'">
            <div class="title"><span class="t02">{{ this.trafficInfo.SUB_STN_NM }}역</span></div>
            <div class="text">
                <span class="pop_bt_state blue">{{ ['신분당선','수인분당선'].includes(this.trafficInfo.SUB_STN_LINE) ? this.trafficInfo.SUB_STN_LINE : this.trafficInfo.SUB_STN_LINE + '호선' }}</span>
                <span>{{ this.trafficInfo.SUB_STN_RADDR }}</span>
            </div>
            <!--<div class="text">
                    <span>기준일 넣을 부분</span>
            </div> -->
            <div class="pop_table02">
                <table>
                    <colgroup>
                        <col style="width: 12%;">
                        <col style="width: 30%;">
                        <col style="width: 30%;" v-if="!$_WC.isMobile">
                    </colgroup>
                    <tbody>
                        <tr>
                            <td class="left">
                                지하철호선
                            </td>
                            <td>지하철노선명</td>
                            <td v-if="!$_WC.isMobile">열차 도착 메세지</td>
                        </tr>
                        <tr v-for="(subway, idx) in this.trafficInfo.SUB_DETAIL" :key="'subway_pop' + idx">
                            <td class="left">
                                {{ subway.SUB_LINE }}
                            </td>
                            <td>{{ subway.SUB_ROUTE_NM }}</td>
                            <td v-if="!$_WC.isMobile">{{ subway.SUB_ARMG1 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'pk'">
            <div class="title"><span class="t02">주차장명 | {{ this.trafficInfo.PRK_NM }}</span></div>
            <div class="text">
                <span class="pop_bt_state blue">{{ this.trafficInfo.PAY_YN == 'Y' ? '유료' : this.trafficInfo.PAY_YN }}</span>
                <span>{{ this.trafficInfo.ADDRESS }}</span>
            </div>
            <!--<div class="text">
                    <span>기준일 넣을 부분</span>
            </div> -->
            <div class="pop_table02">
                <table>
                    <colgroup>
                        <col style="width: 12%;">
                        <col style="width: 60%;">
                    </colgroup>
                    <tbody>
                        <tr v-if="this.trafficInfo.CUR_PRK_YN == 'Y'">
                            <td class="left">주차현황</td>
                            <td>{{ this.trafficInfo.CUR_PRK_CNT }}/{{ this.trafficInfo.CPCTY }}</td>
                        </tr>
                        <tr>
                            <td class="left">기본요금</td>
                            <td>{{ this.trafficInfo.RATES }}원/{{ this.trafficInfo.TIME_RATES }}분</td>
                        </tr>
                        <tr>
                            <td class="left">추가요금</td>
                            <td>{{ this.trafficInfo.ADD_RATES }}원/{{ this.trafficInfo.ADD_TIME_RATES }}분</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'cg'">
            <div class="title"><span class="t02">{{ this.trafficInfo.STAT_NM }}</span></div>
            <div class="text">
                <span class="pop_bt_state blue">{{ this.trafficInfo.STAT_KINDDETAIL }}</span>
                <span>{{ this.trafficInfo.STAT_ADDR }}</span>
            </div>
            <div class="pop_table03">
                <table>
                    <colgroup>
                        <col style="width: 40%;">
                        <col style="width: 60%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>전기차충전소 이용자 제한</th>
                            <td>{{ this.trafficInfo.STAT_LIMITYN == 'Y' ? '제한' : '비제한' }} {{ !!this.trafficInfo.STAT_LIMITDETAIL ? ',' +this.trafficInfo.STAT_LIMITDETAIL : '' }}</td>
                        </tr>
                        <tr>
                            <th>전기차충전소 운영시간</th>
                            <td>{{ this.trafficInfo.STAT_USETIME }}</td>
                        </tr>
                        <tr>
                            <th>충전기</th>
                            <td>{{ this.trafficInfo.CHARGER_DETAILS.length }} 대</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pop_table02">
                <table>
                    <colgroup>
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                        <col style="width: 20%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <td class="left">충전기ID</td>
                            <td>충전기 타입</td>
                            <td>충전방식</td>
                            <td>충전기 충전용량</td>
                            <td>충전기 상태</td>
                        </tr>
                        <tr v-for="cd in this.trafficInfo.CHARGER_DETAIL">
                            <td class="left">{{ cd.CHARGER_ID }}</td>
                            <td>{{ cd.CHARGER_TYPE }}</td>
                            <td>{{ cd.METHOD }}</td>
                            <td>{{ cd.OUTPUT }}</td>
                            <td>{{ cd.CHARGER_STAT }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'sbike'">
            <div class="title"><span class="t02">따릉이</span></div>
            <div class="text">
                <span class="pop_bt_state blue">{{ this.trafficInfo.SBIKE_SPOT_ID }}</span>
                <span v-show="spName != '' && epName != ''">{{ this.trafficInfo.SBIKE_SPOT_NM }}</span>
            </div>
            <div class="pop_table03">
                <table>
                    <colgroup>
                        <col style="width: 40%;">
                        <col style="width: 60%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>잔여대수</th>
                            <td>{{ this.trafficInfo.SBIKE_PARKING_CNT }}/{{ this.trafficInfo.SBIKE_RACK_CNT }}</td>
                        </tr>
                        <tr>
                            <th>거치율</th>
                            <td>{{ this.trafficInfo.SBIKE_SHARED }}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
        <div class="popup_wrap" v-if="this.trafficInfo.key == 'bus'">
            <div class="title"><span class="t02">버스정류장</span></div>
            <div class="text">
                <span class="pop_bt_state blue">{{ this.trafficInfo.BUS_STN_NM }}</span>
                <span>정류소ID: {{ this.trafficInfo.BUS_STN_ID }}</span>
            </div>
        </div>
        
        <div class="pop_bt_close"><a href="#" class="self-close-btn">닫기</a></div>
        <div class="pop_bt_close2"><a href="#" class="self-close-btn">닫기</a></div>
    </div>
</template>

<script>
module.exports = {
    data: function() {
        return {
            trafficInfo: {}
        };
    },
    computed: {
        rdName: function() {
            return this.trafficInfo.ROAD_NM;
        },
        spName: function() {
            return this.trafficInfo.START_ND_NM;
        },
        epName: function() {
            return this.trafficInfo.END_ND_NM;
        },
        speed: function() {
            return this.trafficInfo.SPD;
        },
        state: function() {
            return this.trafficInfo.IDX;
        },
        clazz: function() {
            if(this.trafficInfo.IDX === '원활') {
                return 't_green';
            } else if(this.trafficInfo.IDX === '서행') {
                return 't_yellow';
            } else if(this.trafficInfo.IDX === '정체') {
                return 't_red';
            }
        },
        distance: function() {
            return this.trafficInfo.DIST;
        },
    }, 
    
    updated: function() {
        this.$emit('loaded-traffic-info', this.$el.innerHTML);
    },
    
    methods: {
        setTrafficInfo: function(trafficInfo) {
            this.trafficInfo = Object.assign({}, trafficInfo);
        }
    }
}
</script>

<style>

</style>